import { Component, inject } from '@angular/core';

import { SessionIdleService } from '../../services/session-idle.service';
import { UI } from '../ui';

/**
 * Idle warning dialog for the admin dashboard (PCI 15-minute inactivity).
 */
@Component({
  selector: 'app-session-idle-modal',
  standalone: true,
  imports: [...UI],
  template: `
    @if (idle.warningOpen()) {
      <div
        class="fixed inset-0 z-2000 grid place-items-center bg-overlay"
        role="dialog"
        aria-modal="true"
        aria-labelledby="idle-title"
      >
        <div class="w-[calc(100%-2rem)] max-w-105 rounded-xl border border-border bg-card p-6 text-fg shadow-xl">
          <h2 id="idle-title" class="m-0 mb-3 text-xl font-semibold" i18n="@@idle.title">Still there?</h2>
          <p class="m-0 leading-snug text-fg-secondary" i18n="@@idle.body">
            Your session will end in {{ idle.secondsLeft() }} seconds due to inactivity.
          </p>
          <div class="mt-5 flex justify-end gap-3">
            <button type="button" uiButton variant="outline" (click)="idle.leave()" i18n="@@idle.leave">
              Leave
            </button>
            <button type="button" uiButton variant="primary" (click)="idle.stay()" i18n="@@idle.stay">
              Stay signed in
            </button>
          </div>
        </div>
      </div>
    }
  `,
})
export class SessionIdleModalComponent {
  readonly idle = inject(SessionIdleService);
}
